import {styled} from '@esgi/ui/theme';
import {OneLinedText} from '@esgi/main/kits/common';

export const TestNameStyled = styled(OneLinedText, {
	minWidth: '50px',
});